import { InjectionToken } from '@angular/core';
export const PRODUCT_PROMOTIONS_ROUTE_PATH = new InjectionToken<string>('PRODUCT_PROMOTIONS_ROUTE_PATH');
